import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import Layout from "components/structure/Layout";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useNavigate } from 'react-router-dom';

const AccessDeniedPage = () => {
  const navigate = useNavigate();

  return (
    <Layout title="Access Denied">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          textAlign: 'center',
          padding: '20px'
        }}
      >
        <ErrorOutlineIcon sx={{ fontSize: 64, color: '#EF7D00', marginBottom: 2 }} />
        <Typography variant="h5" sx={{ color: '#112A63', marginBottom: 2 }}>
          Access Denied
        </Typography>
        <Typography variant="body1" sx={{ color: '#737D86', marginBottom: 4 }}>
          Global users do not have access to the translation.
        </Typography>
        
      </Box>
    </Layout>
  );
};

export default AccessDeniedPage;